import mudeyRating1 from "~images/mudey_rating1.svg";
import mudeyRating2 from "~images/mudey_rating2.svg";
import mudeyRating3 from "~images/mudey_rating3.svg";
import mudeyRating4 from "~images/mudey_rating4.svg";
import mudeyRating5 from "~images/mudey_rating5.svg";

export const genderList = [
  { value: "M", label: "Masculino" },
  { value: "F", label: "Feminino" },
];
export const maritalList = [
  { value: "DIVORCED", label: "Divorciado(a)" },
  { value: "MARRIED", label: "Casado(a)" },
  { value: "SINGLE", label: "Solteiro(a)" },
  { value: "WIDOWED", label: "Viúvo(a)" },
];

export const image = {
  "1": mudeyRating1,
  "2": mudeyRating2,
  "3": mudeyRating3,
  "4": mudeyRating4,
  "5": mudeyRating5,
};

export const productList = {
  TRAVEL: "Viagem",
  MORTGAGE: "Vida Crédito",
  CAR: "Auto Particulares",
  CARCOMPANIES:"Auto Empresas",
  WORKACCIDENTCOMPANIES:"AT Outrem",
  BIKE: "Moto",
  HOME: "Casa",
  DEPENDENT: "AT Outrem",
  INDEPENDENT: "AT Indep.",
  OTHER: "Outro",
  HEALTH: "Saúde",
  WORKACCIDENT: "AT Indep.",
  HOUSEKEEPER: "Empregada Doméstica",
  LIFE: "Vida Proteção",
  THIRDPARTY:"Resp. Civil",
  // Receipts show raw English types without a label here, so every Libax policy type needs one (QA 30/10).
  BICYCLE: "Bicicleta",
  BOAT: "Embarcação",
  CHILD: "Criança",
  CRITICALILLNESS: "Doenças Graves",
  DENTAL: "Dentário",
  DRONE: "Drone",
  EXTENDEDWARRANTY: "Garantia Estendida",
  FAMILY: "Família",
  GADGET: "Gadgets",
  HOSPITALIZATION: "Hospitalização",
  HUNTER: "Caçador",
  INCOME: "Rendimento",
  INVESTMENT: "Investimento",
  IOB: "Resp. Civil Profissional",
  LOCALLODGING: "Aloj. Local",
  MOBILE: "Telemóvel",
  PERSONALACCIDENT: "Acid. Pessoais",
  PET: "Animal Doméstico",
  PPR: "PPR",
  RETAIL: "Retalho",
  SCOOTER: "Trotinete",
  WARRANTY: "Garantia",
  WHITEGOODS: "Eletrodomésticos",
};
